export const ISSUE_CATEGORIES = [
  {
    key: 'photo_issues',
    label: 'Photo issues',
    details: [
      {
        key: 'no_matching_photos_found',
        label: 'No matching photos found',
      },
      {
        key: 'missing_some_matching_photos',
        label: 'Missing some matching photos',
      },
      {
        key: 'wrong_matches_delivered',
        label: 'Wrong matches delivered',
      },
      {
        key: 'fewer_photos_than_expected_count',
        label: 'Number of photos less than expected',
      },
      {
        key: 'photos_added_wrong_album',
        label: 'Photos added to the wrong album',
      },
      {
        key: 'poor_quality_purchased_prints',
        label: 'I purchased prints and the quality is poor',
      },
    ],
  },
  {
    key: 'app_support',
    label: 'App Support',
    details: [
      {
        key: 'join_code_help',
        label: "I have a join code but don't know how to use it",
      },
      {
        key: 'sharing_trouble',
        label: "I'm having trouble sharing photos with family",
      },
      {
        key: 'international_number',
        label: "I'm having trouble because I have an international number",
      },
      {
        key: 'app_usage_help',
        label: "I'm not sure how to use the app",
      },
      {
        key: 'web_gallery_access',
        label: "I'm trying to view the web gallery",
      },
    ],
  },
  {
    key: 'account_billing',
    label: 'Account & Billing',
    details: [
      {
        key: 'paid_not_seeing_event',
        label: "I paid but I'm not seeing my event",
      },
      {
        key: 'signed_up_wrong_event',
        label: 'I signed up for the wrong event',
      },
      {
        key: 'cancel_subscription',
        label: 'I want to cancel my subscription',
      },
      {
        key: 'request_refund',
        label: "I'd like to request a refund",
      },
    ],
  },
  {
    key: 'other',
    label: 'Other',
    details: [
      {
        key: 'instructions',
        label: 'I need instructions on how to sign up or view photos',
      },
      {
        key: 'waldogram_not_received',
        label: "I sent a Waldogram and it wasn't received",
      },
      {
        key: 'feedback_or_suggestion',
        label: 'I have feedback or a suggestion',
      },
    ],
  },
];

export const ISSUE_CATEGORY_PLACEHOLDER = 'Select...';
export const ISSUE_DETAIL_PLACEHOLDER = 'Select...';

export const getIssueDetails = issueCategoryKey => {
  return (
    ISSUE_CATEGORIES.find(category => category.key === issueCategoryKey)
      ?.details ?? []
  );
};

export const getIssueCategoryLabel = issueCategoryKey => {
  return ISSUE_CATEGORIES.find(category => category.key === issueCategoryKey)
    ?.label;
};

export const getIssueDetailLabel = (issueCategoryKey, issueDetailKey) => {
  return getIssueDetails(issueCategoryKey).find(
    detail => detail.key === issueDetailKey,
  )?.label;
};
